import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from '@/router'
import i18n from '@/i18n'
import '@/assets/styles/base.css'
import '@/assets/styles/main.css'
import '@/assets/styles/responsive.css'

// Ignore known browser ResizeObserver loop noise in dev overlay.
const RESIZE_OBSERVER_ERROR_MESSAGES = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded'
]

const isResizeObserverNoise = (message) => {
  const text = String(message || '')
  return RESIZE_OBSERVER_ERROR_MESSAGES.some(msg => text.includes(msg))
}

window.onerror = function (message) {
  if (isResizeObserverNoise(message)) {
    return true
  }
  return false
}

window.addEventListener('error', (event) => {
  const message = event?.message || event?.error?.message
  if (isResizeObserverNoise(message)) {
    event.preventDefault()
    event.stopImmediatePropagation()
  }
}, true)

window.addEventListener('unhandledrejection', (event) => {
  const message = event?.reason?.message || event?.reason
  if (isResizeObserverNoise(message)) {
    event.preventDefault()
  }
})

if (process.env.NODE_ENV === 'development') {
  const originalConsoleError = window.console.error
  window.console.error = (...args) => {
    const joined = args.map(v => (typeof v === 'string' ? v : (v?.message || ''))).join(' ')
    if (isResizeObserverNoise(joined)) {
      return
    }
    originalConsoleError.apply(window.console, args)
  }
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.BASE_URL}sw.js`).catch(() => {})
  })
}

const app = createApp(App)

app.use(ElementPlus)
app.use(i18n)
app.use(router)

app.mount('#app')